import Vue from 'vue'
// Lib imports
import axios from 'axios'
var production = true
Vue.prototype.$app_mode = "production"
var SERVER = " http://localhost:4001"
if(production) {
  if(Vue.prototype.$app_mode == "production")
       SERVER = "https://srv.bluefinph.com"
  else if(Vue.prototype.$app_mode == "beta")
        SERVER = "https://cagayan.powerplay88.net"
}
Vue.prototype.$http = axios.create({
  baseURL: SERVER + '/api/'
})

Vue.prototype.$fileserver = SERVER + '/public/' 